import React from "react";
import PageLayout from "../../layouts/PageLayout";
import { Box, Heading } from "../../components/elements";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function UniswapListing() {
    return (
        <PageLayout>
        <Helmet>
          <title>Uniswap Listing</title>
          <meta name="description" content="Get Listed on Uniswap, Boost your token’s trading potential with up to $100,000 in liquidity" />
          <meta name="keywords" content="uniswap listing, liquidity, trade, swap, uniswap" />
          <meta name="author" content="0xFactory" />

          {/* Open Graph (for Facebook, LinkedIn, etc.) */}
          <meta property="og:title" content="Uniswap Listing" />
          <meta property="og:description" content="Get Listed on Uniswap, Boost your token’s trading potential with up to $100,000 in liquidity" />
          <meta property="og:image" content="https://i.ibb.co/DPh6j6HM/coin.png" />
          <meta property="og:url" content="https://0xfactory.com/uniswap" />
          <meta property="og:type" content="website" />

          {/* Twitter Card (for Twitter sharing) */}
          <meta name="twitter:title" content="Uniswap Listing" />
          <meta name="twitter:description" content="Get Listed on Uniswap, Boost your token’s trading potential with up to $100,000 in liquidity" />
          <meta name="twitter:image" content="https://i.ibb.co/DPh6j6HM/coin.png" />
          <meta name="twitter:card" content="stable_token" />
        </Helmet>
            <Container fluid>
                <Heading as="h2" className="mc-overview-title">Uniswap Listing</Heading>
                    <Row xs={1} sm={2} xl={2}>
                            <Col xs={12} sm={8} xl={8}>
                                <div className="text-center">
                                  <h2 style={{color: 'yellow'}}>Your token will be instantly tradable!</h2>
                                </div>
                                <br />
                                <div>
                                    Boost your token’s trading potential with up to $100,000 in liquidity, Enhance investor confidence and market depth instantly.
                                </div>
                                <br/>
                                <div>
                                    Perfect for new launches or scaling existing projects.
                                </div>
                                <br />
                                <div className="text-center">
                                  <h2 style={{color: 'yellow'}}>"Up to $100,000 of liquidity for your token"</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <h1>Get Listed on Uniswap</h1>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <h1>Standard & Stable Tokens Supported</h1>
                                </div>
                                <br/>
                                <div><h3>- No USDT or BNB needed for liquidity.</h3></div>
                                <div><h3>- Get up to $100,000 of liquidity value.</h3></div>
                                <div><h3>- Your token will be pair with ZXF.</h3></div>
                                <div><h3>- Enable your token community to trade effortlessly with minimal slippage.</h3></div>
                                <div><h3>- No chart avaliable for this pool.</h3></div>
                                <div><h3>- For BSC Tokens Only.</h3></div>
                                <br/>
                                <div><h3 style={{color: 'red'}}>Note: Stable and standard tokens exchanges may experience a 0.5% to 1% deduction due to %0.3 exchange fee + uniswap & network fee.</h3></div>
                                <br/>

                                <h4><h3>Listing : $50</h3></h4>
                                <br/>
                                <h4><h3>Token + Listing : $99</h3></h4>
                                <br/>
                                <br/>
                                <div className="text-center">
                                <a href="https://app.uniswap.org/swap/?chain=bnb&outputCurrency=0x4fec070c37181c22c4c550301c83af1950141c17" target="_blank" rel="noreferrer"><h3 style={{color: 'yellow'}}>Standard Token Demo</h3></a>
                                &nbsp;&nbsp;|&nbsp;&nbsp;
                                <a href="https://app.uniswap.org/swap/?chain=bnb&outputCurrency=0xB62D20f527490D78837c8656f6a28331D7723b34" target="_blank" rel="noreferrer"><h3 style={{color: 'yellow'}}>Stable Token Demo</h3></a>
                                </div>
                                <br/>
                                <div className="text-center">
                                <a href="https://t.me/mohamedmox" target="_blank" rel="noreferrer"><h3 style={{color: 'yellow'}}>Contact Us To Get The Offer</h3></a>
                                </div>
                                <br/>
                            </Col>
                            <Col xs={12} sm={4} xl={4}>
                                <Box>
                                    <div className="text-center">
                                        <img src="images/uniswap.png" width={"100%"} alt="Social Image" />
                                    </div>
                                    <br/>
                                </Box>
                            </Col>
                    </Row>
                </Container>
        </PageLayout>
    )
}
